export default __webpack_public_path__ + "static/media/info-filled.2fc272ce.svg";